module.exports = __webpack_public_path__ + "fonts/Montserrat-Thin.520c5328.woff2";